import { render, staticRenderFns } from "./orderDetailView.vue?vue&type=template&id=e6a945b4&"
import script from "./orderDetailView.vue?vue&type=script&lang=js&"
export * from "./orderDetailView.vue?vue&type=script&lang=js&"
import style0 from "./orderDetailView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports